document.addEventListener('DOMContentLoaded', () => {
    document
        .querySelectorAll('[data-form-field]')
        .forEach(input => {
            input.addEventListener('input', () => {
                validateRegexField(input);
            });

            input.addEventListener('blur', () => {
                validateRegexField(input);
            });
        });

    document.querySelectorAll('form').forEach(form => {
        form.addEventListener('submit', event => {
            if (!validateForm(form)) {
                event.preventDefault();

                const firstInvalid =
                    form.querySelector('[aria-invalid="true"]');

                firstInvalid?.focus();
            }
        });
    });
});

function validateRegexField(input) {
    const pattern = input.dataset.validationRegex;
    const value = input.value;

    if (!pattern) {
        return true;
    }

    // Optional fields don't need to satisfy their regex
    // when they're completely empty.
    if (!input.required && value === '') {
        setFieldValid(input);
        return true;
    }

    try {
        const regex = new RegExp(pattern);
        const isValid = regex.test(value);

        if (isValid) {
            setFieldValid(input);
            return true;
        }

        setFieldInvalid(input);
        return false;
    }
    catch (error) {
        console.error('Invalid editor regex:', pattern, error);
        return true;
    }
}

function validateForm(form) {
    let isValid = true;

    form
        .querySelectorAll('[data-form-field]')
        .forEach(input => {
            if (!validateRegexField(input)) {
                isValid = false;
            }
        });

    return isValid;
}

function setFieldValid(input) {
    const wrapper = input.closest('.input-wrapper');

    input.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');

    wrapper?.classList.remove('has-validation-error');

    const errorElement = wrapper?.querySelector('.input-validation-error');

    if (errorElement) {
        errorElement.textContent = '';
    }
}

function setFieldInvalid(input) {
    const wrapper = input.closest('.input-wrapper');

    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');

    wrapper?.classList.add('has-validation-error');

    const errorElement = wrapper?.querySelector('.input-validation-error');

    if (errorElement) {
        errorElement.innerHTML =
            input.dataset.validationMessage || 'Invalid value.';
    }
}